function Intro3() {
	return ( 
		<>
				<p>
					30 Jahre wird es dauern, bis diese Fichtenstämme im Wald von Insekten, Pilzen, Asseln, Würmern und anderen Lebensformen zu Humus zersetzt sein werden. Im virtuellen Klangraum «DE-COMPOSING TREES» hören Sie diese biologischen Prozesse – künstlerisch übersetzt.
				</p>
		</>
	 );
}

export default Intro3;